enum ExternalLinks {
  E_VERIFY = 'https://www.e-verify.gov',
}

export default ExternalLinks;
